/**
 * This module is now converted into a Vue Plugin.
 * https://vuejs.org/v2/guide/plugins.html
 */

// deps
// import lodash from 'lodash';
import moment from 'moment-timezone';
import Vue from 'vue';
// import haversine from 'haversine';

declare global {
    interface Window {
        language: string
    }
}

export const FCVue = {
  install(): void {
    Vue.prototype.$bus = new Vue();
    // Vue.prototype.$lodash = lodash;
    Vue.prototype.$findOne = (haystack: string, arr: string[]) => {
      return arr.some(val => haystack.includes(val));
    };

    Vue.prototype.geoFormat = (lat: number, lng: number) => {
      return { lat : Number(lat), lng : Number(lng) };
    };

    // Vue.prototype.geoDistance = haversine;

    // filters
    Vue.filter('mreldate', function(date: string, time: string, timezone: string) {

      moment.locale(window.language);    // language set in top-level fc3_components.js.

      if (!(time && timezone)) {
        // when no time given, fromNow sets time to 00:00:00 in machine's timezone, can result in odd relative times
        return moment.utc(date, 'YYYY-MM-DD').fromNow();
      }

      const dateToModify = time ? `${date} ${time}` : date;
      // We standardize to utc (how times are stored in db), as otherwise, moment will first convert the time to the server's local time
      const utc = moment.utc(dateToModify);

      // Then, convert to the given timezone (default_tz set on group post is on, most likely)
      return utc.tz(timezone).fromNow();
    });

    // this filter strips html tags from text and returns the raw text
    Vue.filter('stripTags', function(text: string) {
      const regex = /(<([^>]+)>)|&nbsp;|&quot;/gim;
      return text.replace(regex, "");
    });

    // this filter is used to truncate a text and add ellipsis or a specified clamping mechanism.
    Vue.filter('truncate', function (text: string, length: number, clamp: string) {
      clamp = clamp || '...';
      length = length || 30;

      if (text.length <= length) return text;

      let tcText = text.slice(0, length - clamp.length);
      let last = tcText.length - 1;


      while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1;

      // Fix for case when text dont have any `space`
      last = last || length - clamp.length;

      tcText = tcText.slice(0, last);

      return tcText + clamp;
    });

    // convert a given string to lowerCase
    Vue.filter('lower', function(text: string) {
      return String(text).toLowerCase();
    });

    // convert string to first uppercase, rest lowercase
    Vue.filter('firstupper', function(text: string) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    });
  }
};
